var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyContentLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2955_96028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.001C0 13.8801 13.8792 0.000976562 31 0.000976562H33C50.1208 0.000976562 64 13.8801 64 31.001V33.001C64 50.1218 50.1208 64.001 33 64.001H31C13.8792 64.001 0 50.1218 0 33.001V31.001Z",
    fill: "#3778FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2955_96028)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 64,
    height: 64,
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3363 20.001C25.3655 20.001 21.3359 24.0306 21.3359 29.0013C21.3359 33.9721 25.3655 38.0017 30.3363 38.0017C32.2977 38.0017 34.1126 37.3743 35.5912 36.3092L41.9496 42.6676L44.0026 40.6147L37.6441 34.2562C38.7093 32.7776 39.3367 30.9628 39.3367 29.0013C39.3367 24.0306 35.3071 20.001 30.3363 20.001ZM24.2393 29.0013C24.2393 25.634 26.969 22.9043 30.3363 22.9043C33.7036 22.9043 36.4333 25.634 36.4333 29.0013C36.4333 32.3686 33.7036 35.0983 30.3363 35.0983C26.969 35.0983 24.2393 32.3686 24.2393 29.0013Z",
    fill: "#818387"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyContentLoupe);
export default __webpack_public_path__ + "static/media/EmptyContentLoupe.e4989566e7646f2d1f4191b30283d243.svg";
export { ForwardRef as ReactComponent };